import script from "./BoardTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardTile.vue?vue&type=script&setup=true&lang=ts"

import "./BoardTile.vue?vue&type=style&index=0&id=d3ff9e4e&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3ff9e4e"],['__file',"BoardTile.vue"]])

export default __exports__